function checkFormValidity(info, fields) {
    return fields
        .filter(({required}) => required)
        .every(({name}) => info.hasOwnProperty(name) && !!info[name])
    ;
}

export default checkFormValidity;
